"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.askForVoucher.name': 'Voucher Request',
    'tools.askForVoucher.description': 'Detect voucher or discount requests from user messages and trigger client-side voucher actions',
};
